import router from "@/router";
import {AxiosError, AxiosResponse} from "axios";
import {RouteLocationRaw} from "vue-router";
import {ROUTE} from "@/content/pages/routes";

const handleResponse = async (request: Promise<AxiosResponse>) => {
  try {
    const response = await request
    return response.data.item || response.data.items
  } catch (error: any) {
    const redirect = ({
      404: ROUTE.NotFound({}),
      403: ROUTE.NotAllowed({})
    } as { [key: number]: RouteLocationRaw })
      [error.response.data.code as number] ?? ROUTE.Error({})
    await router.push(redirect)

    throw error;
  }
}


export default handleResponse
